export enum OnboardingFlow {
  COMPANY = 'company',
  DEVELOPER = 'developer',
  NORMAL = 'normal',
  PRIVATE = 'private',
  RENTAL = 'rental',
  MAINTENANCE = 'maintenance',
  EMPLOYEE = 'employee'
}
